import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import Sidebar from "./Sidebar";
import { getSessionContext } from "../../common/utils/sessionContext";

const Header = (props) => {
  const [showSideBar, setSideBar] = useState(false);
  const { communityName, caregiverName } = getSessionContext();
  
  const confirmationCallback = () => {
    setSideBar(false);
  };

  const openSideBar = () => {
    setSideBar(true);
  };

  return (
    <div className={`header-container ${props?.noBorderBottom ? "header-no-border-bottom" : ""}`}>
      <div className="header-left">
        {showSideBar ? (
          <Sidebar
            showSideBar={confirmationCallback}
            communities={props?.communities}
            showHamBergIcon={(data) => confirmationCallback(data)}
          />
        ) : (
          <GiHamburgerMenu className="caregiver-header-icon" onClick={openSideBar} />
        )}
        <img src={require("../../assets/btTree.png")} alt="key" style={{ padding: "0px 10px" }} />
      </div>
      <div className="header-right" style={{ textAlign: "center" }}>
        <span className="community-name">{communityName}</span>
        <span className={!communityName ? "cg-name cg-name-no-community" : "cg-name"}>{caregiverName}</span>
      </div>
    </div>
  );
};

export default Header;
